import { useState } from 'preact/hooks';
import {
  PosBottomSheetProvider,
  PosBottomSheetType,
} from './PosBottomSheetProvider';
import MerchantService from '../../services/merchant.service';
import NavigationUtils from '../../utils/navigation.utils';
import { EnterAmountType } from '../../routes/EnterAmountPage/EnterAmountProvider';
import useTranslation from '../../localization/i18n.context';
import { DeeplinkEvent } from '../../sdk/deeplink.event';
import CardStatus from '../../constants/card.status';
import BottomSheetLayout from '../shared/BottomSheetLayout/BottomSheetLayout';

export default function PosBottomSheet({
  show = false,
  organizationCode,
  isHome = false,
  cardStatus = '',
  cardUid = '',
}) {
  const { t, getOrganization } = useTranslation();
  const [showBottomSheet, setShowBottomSheet] = useState(show);
  const [value, setValue] = useState(null);
  const data = PosBottomSheetProvider(t, getOrganization(organizationCode));

  function getMerchantId() {
    MerchantService.getMerchant()
      .then(response => {
        const merchantId = response?.data?.merchantId;
        if (merchantId) {
          navigateBasedOnCardStatus(merchantId);
        } else {
          navigateToMerchant();
        }
      })
      .catch(er => {
        console.error(`Something went wrong during merchant data fetching`, er);
        NavigationUtils.navigate(NavigationUtils.Routes.TRY_AGAIN);
      });
  }

  function navigateToMerchant() {
    if (isHome) {
      DeeplinkEvent.openWebview(
        `${NavigationUtils.Routes.MERCHANT}?organizationCode=${organizationCode}&source=${NavigationUtils.Sources.HOME}`,
      );
    } else {
      NavigationUtils.navigate(NavigationUtils.Routes.MERCHANT, false, {
        organizationCode: organizationCode,
        source: NavigationUtils.Sources.WALLET,
      });
    }
  }

  function navigateBasedOnCardStatus(merchantId) {
    const lockedCard = cardStatus === CardStatus.LOCKED;
    if (isHome) {
      const navigationRoute = lockedCard
        ? `${NavigationUtils.Routes.CARD_SETTINGS}?source=${NavigationUtils.Sources.HOME}&organization=${organizationCode}&cardUid=${cardUid}`
        : `${NavigationUtils.Routes.ENTER_AMOUNT}?organizationCode=${organizationCode}&type=${EnterAmountType.POS}&merchantId=${merchantId}&source=${NavigationUtils.Sources.HOME}`;
      DeeplinkEvent.openWebview(navigationRoute);
    } else {
      if (lockedCard) {
        NavigationUtils.navigate(NavigationUtils.Routes.CARD_SETTINGS, false, {
          organizationCode: organizationCode,
          source: NavigationUtils.Sources.WALLET,
          cardUid: cardUid,
        });
      } else {
        NavigationUtils.navigate(NavigationUtils.Routes.ENTER_AMOUNT, false, {
          organizationCode: organizationCode,
          source: NavigationUtils.Sources.WALLET,
          type: EnterAmountType.POS,
          merchantId: merchantId,
        });
      }
    }
  }

  function onConfirmBottomSheetButtonClick() {
    setShowBottomSheet(false);
    switch (value.type) {
      case PosBottomSheetType.TOP_UP_CARD: {
        if (isHome) {
          DeeplinkEvent.openWebview(
            `${NavigationUtils.Routes.TOPUP}?organization=${organizationCode}&source=${NavigationUtils.Sources.HOME}`,
          );
        } else {
          NavigationUtils.navigate(NavigationUtils.Routes.TOPUP, false, {
            source: NavigationUtils.Sources.WALLET,
            organizationCode: organizationCode,
          });
        }
        break;
      }
      case PosBottomSheetType.TOP_UP_POS: {
        getMerchantId();
        break;
      }
    }
  }

  return (
    <BottomSheetLayout
      showBottomSheet={showBottomSheet}
      title={data.title}
      items={data.items}
      titleStyle={data.titleStyle}
      selectedItem={value}
      onClose={() => setShowBottomSheet(false)}
      onItemClick={setValue}
      onButtonClick={onConfirmBottomSheetButtonClick}
      buttonTitle={data.buttonTitle}
    />
  );
}
